import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

import { Text } from '@ingka/common-styles-webc';

export default class ProductListTotalPriceStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options object.
	 * @param options.theme Theme.
	 * @param options.isTroOrFamilyPrice If it is family price or TRO (Time Restricted Offer).
	 * @param options.collectable Whether to show the collect checkbox or not.
	 * @param options.isMobile ...
	 * @param options.isTablet ...
	 * @returns Styles.
	 */
	public static getStyle(options: {
		theme: ITheme;
		isTroOrFamilyPrice: boolean;
		collectable: boolean;
		isMobile: boolean;
		isTablet: boolean;
	}): string {
		const { spacing, color } = options.theme;
		return css`
			${Text.CSS}
			:host {
				display: block;
			}

			.container {
				display: grid;
				grid-gap: ${spacing.space100 / 16}rem;
				grid-template-columns: ${64 / 16}rem 4fr 3fr 2fr 3fr ${options.collectable ? '2fr' : ''};
				padding-top: ${spacing.space100 / 16}rem;
			}

			.total {
				display: flex;
				justify-content: flex-end;
			}

			.total p,
			.numberOfItems p {
				color: ${color.text.dark};
				margin: 0;
			}

			.bold {
				font-weight: bold;
			}

			.numberOfItems {
				display: flex;
				justify-content: center;
			}
			.numberOfItems p {
				margin: 0;
			}

			.divider {
				display: flex;
				flex-shrink: 0;
				width: ${spacing.space25 / 16}rem;
			}

			.total .numberOfItems {
				display: none;
			}

			.total,
			.numberOfItems {
				padding-top: ${options.isTroOrFamilyPrice ? spacing.space150 / 16 : 0}rem;
			}

			kompis-price-module {
				align-items: flex-end;
				text-align: end;
			}

			${this.getDeviceStyle(options)}
		`;
	}

	public static getCompactLayoutStyle(options: { theme: ITheme }): string {
		const { spacing, color } = options.theme;
		return css`
			${Text.CSS}
			.compactPriceWrapper {
				display: flex;
				flex-direction: column;
				align-items: end;
				color: ${color.text.dark};
				margin-top: ${spacing.space50 / 16}rem;
			}

			.compactPriceWrapper p {
				margin: 0;
			}

			.compactPrice:not(:last-child) {
				margin-bottom: ${spacing.space25 / 16}rem;
			}

			.compactPrice {
				color: inherit;
			}

			.compactCommercialMessage {
				margin-bottom: ${spacing.space25 / 16}rem;
				color: inherit;
			}

			.bold {
				font-weight: bold;
			}
		`;
	}

	/**
	 * @param options ...
	 * @param options.theme ...
	 * @param options.isMobile ...
	 * @param options.isTablet ...
	 * @returns Mobile style for product list total price.
	 */
	private static getDeviceStyle(options: {
		theme: ITheme;
		isMobile: boolean;
		isTablet: boolean;
	}): string {
		if (!options.isMobile || !options.isTablet) {
			return '';
		} else if (options.isMobile) {
			return css`
				.container {
					display: flex;
					flex-direction: row;
				}
				.container .numberOfItems {
					display: none;
				}
				.total .numberOfItems {
					display: flex;
					padding: 0;
					justify-content: flex-start;
				}
				.spacer {
					display: none;
				}
				.total {
					display: flex;
					flex-grow: 1;
					justify-content: flex-start;
					flex-direction: column;
				}
				.spacerDesktop {
					display: none;
				}
			`;
		} else if (options.isTablet) {
			return css`
				.container {
					grid-template-columns: ${64 / 16}rem 4fr 3fr 3fr;
				}
				.spacerDesktop {
					display: none;
				}
			`;
		}
		return '';
	}
}
